<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>屈光参差变焦镜</el-breadcrumb-item>
      <el-breadcrumb-item>屈光参差变焦镜设备管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouQuery"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.sn" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.version" @keyup.enter.native="clicksearch" placeholder="请输入产品版本号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
          <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Jigouname" label="归属机构" min-width="20%"></el-table-column>
          <el-table-column prop="Sn" label="保修卡号" min-width="20%"></el-table-column>
          <el-table-column prop="Version" label="产品版本号" min-width="20%"></el-table-column>
          <el-table-column prop="CreateTime" label="创建时间" min-width="20%" v-if="SubRule_RefractiveDiscrepancyDevice_Add"></el-table-column>
          <el-table-column label="操作" min-width="20%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_RefractiveDiscrepancyDevice_Edit" @click="goModifyDeviceInformation(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加设备 start -->
      <el-tab-pane label="添加设备" v-if="SubRule_RefractiveDiscrepancyDevice_Add">
        <el-form :model="addDevice" ref="addDeviceRef" label-width="75px">
          <el-form-item label="归属机构" class="addAdminForm">
            <Rsljigou :propsjigouid="addDevice.jigouid" :propsjigouname="addDevice.jigouname" @change="changeRsljigouAdd"></Rsljigou>
          </el-form-item>
          <el-form-item label="保修卡号" class="addAdminForm">
            <el-input type="textarea" v-model="addDevice.snlist" placeholder="请从Excel复制多行保修卡号进来"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加设备 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <RefractiveDiscrepancyDeviceEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></RefractiveDiscrepancyDeviceEdit>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import RefractiveDiscrepancyDeviceEdit from '@/componentsSubVue/RefractiveDiscrepancyDeviceEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    RefractiveDiscrepancyDeviceEdit
  },
  name: 'MyRefractiveDiscrepancyDevice',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        jigouid: '-1',
        jigouname: '',
        sn: '',
        version: '',
        begintime: '',
        endtime: ''
      },
      // 添加设备
      addDevice: {
        jigouid: '0',
        jigouname: '',
        snlist: ''
      },
      SubRule_RefractiveDiscrepancyDevice_Add: false,
      SubRule_RefractiveDiscrepancyDevice_Edit: false
    }
  },
  mounted () {
    this.apiGetRefractiveDiscrepancyDeviceNum()
    this.apiGetRefractiveDiscrepancyDeviceList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_RefractiveDiscrepancyDevice_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_RefractiveDiscrepancyDevice_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_RefractiveDiscrepancyDevice_Edit', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_RefractiveDiscrepancyDevice_Edit = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetRefractiveDiscrepancyDeviceList()
    },
    changeRsljigouQuery (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    changeRsljigouAdd (vid, vname) {
      this.addDevice.jigouid = vid
      this.addDevice.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetRefractiveDiscrepancyDeviceList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetRefractiveDiscrepancyDeviceNum()
      this.apiGetRefractiveDiscrepancyDeviceList()
    },
    clickadd () {
      this.apiAddRefractiveDiscrepancyDevice()
    },
    // 修改
    goModifyDeviceInformation (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    apiGetRefractiveDiscrepancyDeviceList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        sn: that.keywords.sn,
        version: that.keywords.version,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRefractiveDiscrepancyDeviceList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetRefractiveDiscrepancyDeviceNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        sn: that.keywords.sn,
        version: that.keywords.version,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRefractiveDiscrepancyDeviceNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddRefractiveDiscrepancyDevice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.addDevice.jigouid,
        snlist: that.addDevice.snlist
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddRefractiveDiscrepancyDevice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addDevice.jigouid = '0'
            that.addDevice.jigouname = ''
            that.addDevice.snlist = ''

            that.apiGetRefractiveDiscrepancyDeviceNum()
            that.apiGetRefractiveDiscrepancyDeviceList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
